import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import AuthModule from './AuthModule';
import Header from './Header';
import StorySlider from './StorySlider';
import '../styles/Feed.css';

const STORIES = [
  {
    id: 'k3g',
    title: 'Kabhi Khushi Kabhi Gham ( Horrorified )',
    description: 'A wealthy Delhi family is haunted by a dark curse from their past when their son returns home with his new bride on their wedding night',
    image: '/assets/story-images/k3g.JPEG',
    publishedDate: '2025-08-11'
  },
  {
    id: 'the-cost-of-a-late-night-maggi',
    title: 'The Cost of a Late-Night Maggi',
    description: 'A couple from Bengaluru visit a remote hill station, where on a late night food run, they find a strange maggi vendor hiding a dark secret',
    image: '/assets/story-images/the-cost-of-a-late-night-maggi.png',
    publishedDate: '2025-07-15'
  },
  {
    id: 'an-age-old-warning',
    title: 'An Age Old Warning',
    description: 'A story of a newly appointment ACF forest officer who is unaware of the tribal practices in the area he is patroling',
    image: '/assets/story-images/an-age-old-warning.png',
    publishedDate: '2025-07-10'
  },
  {
    id: 'revenge-of-the-bloodlines',
    title: 'Revenge of the Bloodlines',
    description: 'A story of an ancient practice in a village which haunts the bloodline of the family',
    image: '/assets/story-images/revenge-of-the-bloodlines.png',
    publishedDate: '2025-07-05'
  },
  {
    id: 'the-lady-on-the-swing',
    title: 'The Lady on the Swing',
    description: 'The story of a lake where public gatherings are forbidden',
    image: '/assets/story-images/the-lady-on-the-swing.png',
    publishedDate: '2025-06-20'
  },
  {
    id: 'the-eyes-that-followed-him-everywhere',
    title: 'The Eyes That Followed Him Everywhere',
    description: 'A man is followed and haunted by a woman throughout his childhood',
    image: '/assets/story-images/the-eyes-that-followed-him-everywhere.png',
    publishedDate: '2025-06-15'
  },
  {
    id: 'the-office',
    title: 'A Nightmare at Dubey Mittal Paper Company',
    description: 'The employees of a small paper company in Jabalpur are terrified by the land their office is built upon',
    image: '/assets/story-images/the-office.PNG',
    publishedDate: '2025-06-01'
  },
  {
    id: '3idiots-horrorified',
    title: '3 Idiots ( Horrorified )',
    description: 'Farhan Qureshi is surprised to find a text from an old college alumini one night, claiming to meet their fugitive batchmate - Rancho',
    image: '/assets/story-images/3idiots-horrorified.JPG',
    publishedDate: '2024-10-20'
  },
  {
    id: 'family-vacation-in-darjeeling',
    title: 'Family Vacation in Darjeeling',
    description: 'A story of an IAS officer and his family who disappear while vacationing in Darjeeling after they fail to listen to the warnings of the caretaker of the vacation bungalow',
    image: '/assets/story-images/family-vacation-in-darjeeling.JPG',
    publishedDate: '2024-10-15'
  },
  {
    id: 'meeting-her-parents',
    title: 'Meeting Her Parents in Sagar ( M.P )',
    description: 'A story of a man who meets the parents of the woman he loves in the small town of Sagar, Madhya Pradesh',
    image: '/assets/story-images/meeting-her-parents.JPG',
    publishedDate: '2024-09-10'
  },
  {
    id: 'dragged-to-the-depths',
    title: 'Dragged to the Depths',
    description: 'A story of an abandoned lake and a recurring dream where a mysterious woman drags a man to the lake',
    image: '/assets/story-images/dragged-to-the-depths.JPG',
    publishedDate: '2024-08-25'
  },
  {
    id: 'bhura-ettan',
    title: 'The Strange Life of Bhura Ettan',
    description: 'A story of a small village in Kerala where villagers start dying mysteriously after a migrant from another state moves in',
    image: '/assets/story-images/bhura-ettan.JPG',
    publishedDate: '2024-08-15'
  },
  {
    id: 'strange-wedding',
    title: 'The Strange Wedding of Dhar',
    description: 'A story of a strange wedding procession that takes place every month around midnight in the city of Dhar',
    image: '/assets/story-images/strange-wedding.JPG',
    publishedDate: '2024-07-20'
  },
  {
    id: 'jadhav-mahal',
    title: 'The Painters of Jadhav Mahal',
    description: 'A story of blood relatives, ancient ruins, paintings, and the unexpected',
    image: '/assets/story-images/jadhav-mahal.JPG',
    publishedDate: '2024-06-30'
  },
  {
    id: 'barfi-bazaar',
    title: 'Barfi Bazaar',
    description: 'A chilling tale of the night guests at a traditional Indian sweets market',
    image: '/assets/story-images/barfi-bazaar.JPEG',
    publishedDate: '2024-05-15'
  },
  {
    id: 'fitness-center',
    title: 'The 24/7 Fitness Center',
    description: 'A story of ambition, friendship, and unexpected challenges',
    image: '/assets/story-images/fitness-center.JPEG',
    publishedDate: '2024-04-10'
  }
];

function Feed() {
  const [showAuth, setShowAuth] = useState(false);
  const [expandedStories, setExpandedStories] = useState(new Set());
  const latestStoriesRef = useRef(null);

  // Get random picks for "Picks for You" section
  const pickedStories = useMemo(() => {
    const shuffled = [...STORIES].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 4);
  }, []);

  // Filter stories by date (within 2 months vs older)
  const { recentStories, olderStories } = useMemo(() => {
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

    const recent = [];
    const older = [];

    STORIES.forEach(story => {
      const storyDate = new Date(story.publishedDate);
      if (storyDate >= twoMonthsAgo) {
        recent.push(story);
      } else {
        older.push(story);
      }
    });

    return { recentStories: recent, olderStories: older };
  }, []);

  const toggleStoryExpansion = (storyId) => {
    setExpandedStories(prev => {
      const newSet = new Set(prev);
      if (newSet.has(storyId)) {
        newSet.delete(storyId);
      } else {
        newSet.add(storyId);
      }
      return newSet;
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (latestStoriesRef.current) {
        latestStoriesRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container">
      <Header onLoginClick={() => setShowAuth(true)} />

      <div className="feed-container">
        {/* Picks for You Section */}
        <div className="picks-section">
          <h2 className="section-title">Picks for You</h2>
          <div className="picks-grid">
            {pickedStories.map(story => (
              <div key={story.id} className="pick-card-wrapper">
                <div 
                  className="pick-card-header"
                  onClick={() => toggleStoryExpansion(story.id)}
                >
                  <div className="pick-image-container">
                    <img src={story.image} alt={story.title} className="pick-image" />
                  </div>
                  <div className="pick-title-section">
                    <h3>{story.title}</h3>
                    <span className="expand-arrow">
                      {expandedStories.has(story.id) ? '\u25bc' : '\u25b6'}
                    </span>
                  </div>
                </div>
                {expandedStories.has(story.id) && (
                  <div className="pick-synopsis">
                    <p>{story.description}</p>
                    <Link to={`/story/${story.id}`} className="read-story-btn">
                      Read Story
                    </Link>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Recent Stories Slider */}
        {recentStories.length > 0 && (
          <div className="latest-stories-section" ref={latestStoriesRef}>
            <h2 className="section-title">Latest Stories</h2>
            <StorySlider 
              stories={recentStories} 
            />
          </div>
        )}

        {/* Older Stories Grid */}
        {olderStories.length > 0 && (
          <div className="older-stories-section">
            <h2 className="section-title">More Stories</h2>
            <div className="stories-grid">
              {olderStories.map(story => (
                <div key={story.id} className="story-card-wrapper">
                  <div 
                    className="story-card-header"
                    onClick={() => toggleStoryExpansion(story.id)}
                  >
                    <div className="story-image-container">
                      <img src={story.image} alt={story.title} className="story-image" />
                    </div>
                    <div className="story-title-section">
                      <h3>{story.title}</h3>
                      <span className="expand-arrow">
                        {expandedStories.has(story.id) ? '▼' : '▶'}
                      </span>
                    </div>
                  </div>
                  {expandedStories.has(story.id) && (
                    <div className="story-synopsis">
                      <p>{story.description}</p>
                      <Link to={`/story/${story.id}`} className="read-story-btn">
                        Read Story
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {showAuth && (
          <div className="auth-popup-overlay" onClick={() => setShowAuth(false)}>
            <div className="auth-popup" onClick={e => e.stopPropagation()}>
              <AuthModule />
              <button className="close-auth" onClick={() => setShowAuth(false)}>×</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Feed; 